import { render, staticRenderFns } from "./SafetyObservationEditForm.vue?vue&type=template&id=f44fb6ec&"
import script from "./SafetyObservationEditForm.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationEditForm.vue?vue&type=script&lang=js&"
import style0 from "./SafetyObservationEditForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports